import React from 'react';

const images = require.context('../../apps/rocket/assets/img/ranks', true);

function Bold({ children }) {
	return (
		<span className='font-museo-sans-medium'>{children}</span>
	);
}

function getRankData(rankId, intl) {
	switch (rankId) {
		case 0: return {
			status: {
				title: 'Beginner',
				image: images('./0.png')
			},
			description: (
				<div>
					{intl('Заработать от 1 до 2 499 QUID за месяц.')}
				</div>
			)
		};
		case 1: return {
			status: {
				title: 'Bronze',
				image: images('./1.png')
			},
			description: (
				<div>
					{intl('При накоплении от')} <Bold>2 500 {intl('до')} 7 499 QUID</Bold> {intl(
						'за месяц. По достижению статуса "Бронза", который необходимо подтверждать ' +
						'ежемесячно, вебмастер получает'
					)} <Bold>х1,1 QUID</Bold> {intl('ко всем заработанным в следующем месяце QUID')}.
				</div>
			)
		};
		case 2: return {
			status: {
				title: 'Silver',
				image: images('./2.png')
			},
			description: (
				<div>
					{intl('При накоплении от')} <Bold>7 500 {intl('до')} 24 999 QUID</Bold> {intl(
						'за месяц. По достижению статуса "Серебро", который необходимо подтверждать ' +
						'ежемесячно, вебмастер получает'
					)} <Bold>х1,2 QUID</Bold> {intl('ко всем заработанным в следующем месяце QUID')}.
				</div>
			)
		};
		case 3: return {
			status: {
				title: 'Gold',
				image: images('./3.png')
			},
			description: (
				<div>
					{intl('При накоплении от')} <Bold>25 000 {intl('до')} 49 999 QUID</Bold> {intl(
						'за месяц. По достижению статуса "Золото", который необходимо подтверждать ' +
						'ежемесячно, вебмастер получает'
					)} <Bold>х1,3 QUID</Bold> {intl('ко всем заработанным в следующем месяце QUID')}.
				</div>
			)
		};
		case 4: return {
			status: {
				title: 'Diamond',
				image: images('./4.png')
			},
			description: (
				<div>
					{intl('При накоплении от')} <Bold>50 000 QUID</Bold> {intl(
						'за месяц. По достижению статуса "Даймонд", который необходимо подтверждать ' +
						'ежемесячно, вебмастер получает'
					)} <Bold>х1,4 QUID</Bold> {intl('ко всем заработанным в следующем месяце QUID')}.
				</div>
			)
		};
		case 5: return {
			status: {
				title: 'Black Member',
				image: images('./5.png')
			},
			description: (
				<div>
					{intl('При накоплении')} <Bold>500 000 QUID</Bold> {intl(
						'за все время использования бонусной программы, вебмастер получает постоянный статус и'
					)} <Bold>х1,5 QUID</Bold> {intl('ко всем заработанным в дальнейшем QUID')}.
				</div>
			)
		};
	}
}

export default getRankData;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/get-rank-data.js